import angular from 'angular';
import iframeOnload from './iframe-onload.directive';

export default angular
  .module('verifyApp.iframe-onload', [])
  .directive('iframeOnload', iframeOnload)
  .name;



// WEBPACK FOOTER //
// ./client/components/iframe-onload/index.js